(function(){let p=null;async function f(){const h=location.pathname.split('/products/')[1]?.split('?')[0];if(!h)return;const r=await fetch('/products/'+h+'.js');p=await r.json()}function g(id){if(!p)return null;const v=p.variants.find(x=>x.id==id);if(!v)return null;const c=v.option2||v.option1;const s=p.variants.filter(x=>(x.option2||x.option1)===c);const m=new Set();s.forEach(x=>{if(x.featured_media)m.add(x.featured_media.id)});return m}function apply(id){const m=g(id);if(!m||!m.size)return;document.querySelectorAll('[data-media-id]').forEach(el=>{el.style.display=m.has(parseInt(el.dataset.mediaId))?'':'none'});document.querySelectorAll('[data-thumbnail-id]').forEach(el=>{el.style.display=m.has(parseInt(el.dataset.thumbnailId))?'':'none'})}async function init(){await f();const id=document.querySelector("input[name='id']")?.value;if(id)apply(id)}document.addEventListener('change',e=>{if(e.target.name==='id')apply(e.target.value)});document.addEventListener('variant:changed',e=>{if(e.detail?.variant?.id)apply(e.detail.variant.id)});document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init()})();(function () {
  let productData = null;

  async function fetchProduct() {
    const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!handle) return;
    try {
      const res = await fetch('/products/' + handle + '.js');
      productData = await res.json();
    } catch(e) {}
  }

  function getColorMediaIds(variantId) {
    if (!productData) return null;
    const variant = productData.variants.find(v => v.id == variantId);
    if (!variant) return null;
    const color = variant.option2 || variant.option1;
    const sameColor = productData.variants.filter(v => (v.option2 || v.option1) === color);
    const ids = new Set();
    sameColor.forEach(v => { if (v.featured_media) ids.add(v.featured_media.id); });
    return ids;
  }

  function applyFilter(variantId) {
    const ids = getColorMediaIds(variantId);
    if (!ids || ids.size === 0) return;
    // Ana görseller - Horizon'da .product-media-container veya direkt [data-media-id]
    document.querySelectorAll('.product-media-container, .product-media[data-media-id]').forEach(el => {
      const mediaEl = el.querySelector('[data-media-id]') || el;
      const mid = parseInt(mediaEl.dataset.mediaId);
      if (!isNaN(mid)) el.style.display = ids.has(mid) ? '' : 'none';
    });
    // Küçük resimler / thumbnail strip
    document.querySelectorAll('[data-thumbnail-id], .thumbnail-list__item').forEach(el => {
      const mid = parseInt(el.dataset.thumbnailId || el.dataset.mediaId);
      if (!isNaN(mid)) el.style.display = ids.has(mid) ? '' : 'none';
    });
  }

  // Horizon'ın kendi variant:update eventi
  document.addEventListener('variant:update', function(e) {
    const variantId = e.detail?.resource?.id;
    if (variantId) applyFilter(variantId);
  });

  // Başlangıçta çalıştır
  fetchProduct().then(() => {
    const idInput = document.querySelector("input[name='id'], select[name='id']");
    if (idInput?.value) applyFilter(idInput.value);
  });
})();